import { _ as s } from "./main49.js";
import { _ as r } from "./main50.js";
import { _ } from "./main51.js";
var a = s, e = r, t = _;
function h() {
  this.size = 0, this.__data__ = {
    hash: new a(),
    map: new (t || e)(),
    string: new a()
  };
}
var o = h;
export {
  o as _
};
